import { Theme, makeStyles } from "@material-ui/core";
import { ILoaderProps } from "./Loader";

export const useStyles = makeStyles<Theme, ILoaderProps>(() => ({
  root: ({ backgroundColor, loaderColor }) => ({
    backgroundColor,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: loaderColor,
  }),
}));
